import { render, staticRenderFns } from "./AiChatBot.vue?vue&type=template&id=0fb5df06"
import script from "./AiChatBot.vue?vue&type=script&lang=js"
export * from "./AiChatBot.vue?vue&type=script&lang=js"
import style0 from "./AiChatBot.vue?vue&type=style&index=0&id=0fb5df06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports